import config from 'src/config';
import { ResponseDto } from 'src/dtos/common/responseDto';
import { deleteData, getData, patchData, postData } from 'src/utils/axios/serverHelper';
import { MST2020_R01Dto } from './Dto_MST2020_R01';
import { MST2020_R01Filter } from './Store_MST2020_R01';

const baseUrl = `${config.apiUrl}/MST2020_R01`;

/** 거래처별 기초잔액 목록 조회 */
export const getMST2020_R01List = async (
	option: string,
	params: Partial<MST2020_R01Filter>,
	listLength: number = 0,
) => getData<ResponseDto<MST2020_R01Dto[]>>(`${baseUrl}/${option}`, {
	params: { ...params, listLength } as MST2020_R01Filter,
});

/** 전체 건수 조회 */
export const getMST2020_R01AllCount = async (params: Partial<MST2020_R01Filter>) =>
	getData<ResponseDto<number>>(`${baseUrl}/allCount`, {
		params: params as MST2020_R01Filter,
	});

/** 기초잔액 등록 (다수) */
export const postMST2020_R01 = async (dtoList: MST2020_R01Dto[]) =>
	postData<MST2020_R01Dto[], ResponseDto<MST2020_R01Dto[]>>(baseUrl, dtoList);

/** 기초잔액 수정 (다수) */
export const patchMST2020_R01 = async (dtoList: MST2020_R01Dto[]) =>
	patchData<MST2020_R01Dto[], ResponseDto<MST2020_R01Dto[]>>(baseUrl, dtoList);

/** 기초잔액 삭제 (단건 PK) */
export const deleteMST2020_R01 = async (dto: MST2020_R01Dto) =>
	deleteData<ResponseDto<void>>(baseUrl, { data: dto });
